import { Position } from '../core';
import type { HandleBound, HandleBounds } from '../core';

export const HANDLE_SELECTOR = '.cm-handle';

const POSITIONS = new Set<string>(Object.values(Position));

const toPosition = (value: string | undefined): Position =>
  value && POSITIONS.has(value) ? (value as Position) : Position.Top;

/**
 * Boxes of the handles inside `nodeElement` in flow units: position from the screen rect relative to the node
 * (divided by `zoom`), size from the layout box. The layout size ignores transforms, so handles in skewed shapes
 * (parallelogram) keep their real size — as in v11.
 */
export const measureHandles = (nodeElement: HTMLElement, zoom: number): HandleBounds => {
  const nodeRect = nodeElement.getBoundingClientRect();
  const bounds: HandleBounds = { source: [], target: [] };
  nodeElement.querySelectorAll<HTMLElement>(HANDLE_SELECTOR).forEach((element) => {
    const rect = element.getBoundingClientRect();
    const type = element.classList.contains('target') ? 'target' : 'source';
    const bound: HandleBound = {
      id: element.dataset.handleid ?? null,
      type,
      position: toPosition(element.dataset.handlepos),
      x: (rect.left - nodeRect.left) / zoom,
      y: (rect.top - nodeRect.top) / zoom,
      width: element.offsetWidth,
      height: element.offsetHeight,
    };
    bounds[type].push(bound);
  });
  return bounds;
};
